import React, { useEffect, useMemo, useState } from "react";
import Swal from "sweetalert2";
import axiosInstance from "../../../utils/axiosInstance";
import { API, unwrap, findStatut, findType, TypeBadge, StatutBadge, formatDate } from "./projetsCommon";
import { exporterRapportProjet } from "./ProjetRapportPdf";

// Page « Rapports » : choisir un projet (y compris terminés) et générer son rapport PDF.
const RapportsProjets = () => {
    const [projets, setProjets] = useState([]);
    const [recherche, setRecherche] = useState("");
    const [enCours, setEnCours] = useState(null);   // id du projet en cours de génération

    useEffect(() => {
        axiosInstance.get(API.projets)
            .then((res) => { const d = unwrap(res); setProjets(Array.isArray(d) ? d : d?.items ?? []); })
            .catch(() => setProjets([]));
    }, []);

    const filtres = useMemo(() => {
        const q = recherche.trim().toLowerCase();
        return projets.filter((p) => !q ||
            [p.code, p.nom, p.clientName, findStatut(p.statut).label, findType(p.type).label]
                .some((v) => (v || "").toLowerCase().includes(q)));
    }, [projets, recherche]);

    const generer = async (id, imprimer) => {
        setEnCours(id);
        try { await exporterRapportProjet(id, { imprimer }); }
        catch { Swal.fire("Erreur", "Impossible de générer le rapport.", "error"); }
        finally { setEnCours(null); }
    };

    return (
        <div className="container-fluid mt-4">
            <h3 className="my-3"><i className="fas fa-file-pdf mr-2"></i>Rapports de projets</h3>
            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <span>Choisissez un projet pour générer sa synthèse imprimable</span>
                    <input className="form-control form-control-sm w-25" placeholder="Rechercher…"
                        value={recherche} onChange={(e) => setRecherche(e.target.value)} />
                </div>
                <div className="card-body p-0">
                    <table className="table table-hover mb-0">
                        <thead>
                            <tr><th>Code</th><th>Projet</th><th>Type</th><th>Statut</th><th>Client</th><th>Fin prévue</th><th className="text-right">Rapport</th></tr>
                        </thead>
                        <tbody>
                            {filtres.length === 0 && <tr><td colSpan="7" className="text-center text-muted py-3">Aucun projet</td></tr>}
                            {filtres.map((p) => (
                                <tr key={p.id}>
                                    <td>{p.code || "—"}</td>
                                    <td>{p.nom}</td>
                                    <td><TypeBadge type={p.type} /></td>
                                    <td><StatutBadge statut={p.statut} /></td>
                                    <td>{p.clientName || "—"}</td>
                                    <td>{formatDate(p.dateFin)}</td>
                                    <td className="text-right text-nowrap">
                                        <button className="btn btn-sm btn-outline-danger mr-1" disabled={enCours === p.id}
                                            title="Télécharger le PDF" onClick={() => generer(p.id, false)}>
                                            {enCours === p.id ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-file-pdf"></i>}
                                        </button>
                                        <button className="btn btn-sm btn-outline-secondary" disabled={enCours === p.id}
                                            title="Imprimer" onClick={() => generer(p.id, true)}>
                                            <i className="fas fa-print"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default RapportsProjets;
